import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareCardInfoMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  cardInfo?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareCardInfoMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardInfo: boolean } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', cardInfo: boolean } } | null } | null };


export const UpdateShareCardInfo = /*#__PURE__*/ gql`
    mutation UpdateShareCardInfo($shareId: ID!, $cardInfo: Boolean) {
  updateShare(input: {shareId: $shareId, appearance: {cardInfo: $cardInfo}}) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          cardInfo
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareCardInfoMutation, UpdateShareCardInfoMutationVariables>;

          

          export const useUpdateShareCardInfoMutation = (options?:MutationHookOptions<UpdateShareCardInfoMutation, UpdateShareCardInfoMutationVariables>) => useMutation(UpdateShareCardInfo, options);
          

          export type UpdateShareCardInfoMutationOptions = MutationHookOptions<UpdateShareCardInfoMutation, UpdateShareCardInfoMutationVariables>;

          

          export type UpdateShareCardInfoMutationResult = ReturnType<typeof useUpdateShareCardInfoMutation>[1];

          
